@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

/* stylelint-disable */
:export {
  colorcovered: $color-primary-purple;
  colorremaining: $color-primary-purple-light;
}
/* stylelint-enable */

.CoverageChartPercent {
  @extend %font-family-primary;

  color: $color-grey-B;
  font-weight: $font-weight-semibold;
  position: relative;
  min-height: 8em;

  .percent {
    position: absolute;
    text-align: center;
    width: 100%;
    top: 50%;
    transform: translateY(-50%);
  }
}
